type MenuIcon = {
    active?: boolean;
    color: string;
    activeColor: string;
}

export function InfoIcon({ active = false, color, activeColor }: MenuIcon) {
    return (
        <>
            {active ?
               
               <svg width="26" height="24" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M26.0635 50.99C39.8635 50.99 51.0635 39.8 51.0635 25.99C51.0635 12.18 39.8635 1 26.0635 1C12.2635 1 1.06348 12.19 1.06348 26C1.06348 39.81 12.2535 51 26.0635 51V50.99ZM22.1535 33.81H24.4935V27.56H22.1535C20.8535 27.56 19.8135 26.52 19.8135 25.22C19.8135 23.92 20.8535 22.88 22.1535 22.88H26.8435C28.1435 22.88 29.1835 23.92 29.1835 25.22V33.81H29.9635C31.2635 33.81 32.3035 34.85 32.3035 36.15C32.3035 37.45 31.2635 38.49 29.9635 38.49H22.1535C20.8535 38.49 19.8135 37.45 19.8135 36.15C19.8135 34.85 20.8535 33.81 22.1535 33.81ZM26.0635 13.5C27.7935 13.5 29.1835 14.9 29.1835 16.62C29.1835 18.34 27.7835 19.74 26.0635 19.74C24.3435 19.74 22.9435 18.34 22.9435 16.62C22.9435 14.9 24.3435 13.5 26.0635 13.5Z" 
               stroke="black" strokeMiterlimit="10" fill={activeColor}/>
               </svg>

               :
               <svg width="26" height="24" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M26.0635 50.99C39.8635 50.99 51.0635 39.8 51.0635 25.99C51.0635 12.18 39.8635 1 26.0635 1C12.2635 1 1.06348 12.19 1.06348 26C1.06348 39.81 12.2535 51 26.0635 51V50.99ZM22.1535 33.81H24.4935V27.56H22.1535C20.8535 27.56 19.8135 26.52 19.8135 25.22C19.8135 23.92 20.8535 22.88 22.1535 22.88H26.8435C28.1435 22.88 29.1835 23.92 29.1835 25.22V33.81H29.9635C31.2635 33.81 32.3035 34.85 32.3035 36.15C32.3035 37.45 31.2635 38.49 29.9635 38.49H22.1535C20.8535 38.49 19.8135 37.45 19.8135 36.15C19.8135 34.85 20.8535 33.81 22.1535 33.81ZM26.0635 13.5C27.7935 13.5 29.1835 14.9 29.1835 16.62C29.1835 18.34 27.7835 19.74 26.0635 19.74C24.3435 19.74 22.9435 18.34 22.9435 16.62C22.9435 14.9 24.3435 13.5 26.0635 13.5Z" 
               stroke={color} strokeMiterlimit="10"/>
               </svg>

           }
        </>
    )
}